export default __webpack_public_path__ + "static/media/settingIcon.be8d391c.svg";